import moment from "moment";
import { Modal } from "antd";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { LoadingOutlined } from "@ant-design/icons";
import Style from "./style";
import { renderNotiBody, renderNotiTitle } from "../Notification/config";
import { useNotificationsHistoryContext } from "./context";
import { ModalHeader } from "datastake-daf/dist/components";

function NotificationHistory({ visible = false, setHistoryVisible = () => { } }) {
  const { t } = useTranslation();
  const { loading, _notifications, _fetch, total } = useNotificationsHistoryContext();

  const groupped = useMemo(() => _notifications.reduce((all, item) => {
    const _key = moment(item.createdAt).format('MMMM YYYY');

    if (all[_key]) {
      all[_key].items.push(item);
    } else {
      all[_key] = { items: [item] };
    }

    return all;
  }, {}), [_notifications]);

  return (
    <Modal
      open={visible}
      width={680}
      footer={null}
      onCancel={() => setHistoryVisible(false)}
      title={(
        <ModalHeader
          title={t('Notification History')}
          supportText={t('Visualise all your notifications here.')}
        />
      )}
    >
      <Style>
        <div
          className="noti-list"
          onScroll={(e) => {
            const _t = e.target;
            const canFetch = (_t.scrollTop + _t.clientHeight) >= _t.scrollHeight - 200;

            if (canFetch) {
              _fetch();
            }
          }}
        >
          {Object.keys(groupped).map((key, i) => (
            <div className="noti-group" key={`${key}-${i}`}>
              <h4>{key}</h4>
              {groupped[key].items.map((n, i) => (
                <div className="noti" key={`${i}-noti-${n.id}`}>
                  <div className="noti-title">
                    <h5>{renderNotiTitle({ n })}</h5>
                    <span>
                      {moment(n.createdAt).format('DD MMM YYYY')}
                    </span>
                  </div>
                  <p>
                    {renderNotiBody({ n })}
                  </p>
                </div>
              ))}
            </div>
          ))}

          {loading && (
            <div className="loading-all">
              <LoadingOutlined />
            </div>
          )}

          {!loading && !total ? (
            <div className="no-notis">
              <p>{t('No new notifications')}</p>
            </div>
          ) : null}
        </div>
      </Style>

    </Modal>
  );
}

export default NotificationHistory;
